import '../pages/About.css';
import profileImage from '../assets/Home/profileImg.jpg';
import React, { useEffect } from 'react';



export default function About() {
    
    useEffect(() => {
        document.title='About';
    })

    return (
        <div className='About'>
            <main className='About-main'>
                <img src={profileImage} className="About-logo" alt="profile" />
                <h1>
                    About Me
                </h1>
                <article>
                    <p>
                        I love to answer questions!
                    </p>
                    <p>
                        My experience as a Software Engineer, my passion leads me to solving my coding problems.
                        Eureka moment occurs at moments whether it's cooking, exercising, playing guitar, or repairing automobiles.
                        I will figure out a solution, put it to test on the computer, and make it work.
                    </p>
                    <p>
                        My name is Jesus Porras.
                        I am a splendid child whose parents emigrated from Spain, passionate about making life easier.
                        As a passionate software engineer, will do what it takes to find an answer.
                    </p>
                    <p>
                        Get in touch and move forward!
                    </p>
                </article>
            </main>
        </div>
    )
}